import { setStorage } from "PFCore/initializers/set_storage";
import { useEffect } from "react";

export const useStorage = () => {
  useEffect(() => {
    setStorage();
  }, []);
};
